import React from 'react';
import './Legend.css'; 

const Legend = ({ colors, labels }) => {
  return (
    <div className="legend-container">
      {colors.map((color, index) => (
        <div key={index} className="legend-item">
          <div
            className="legend-color"
            style={{ backgroundColor: color }}
          />
          <span className="legend-label">{labels[index]}</span>
        </div>
      ))}
    </div>
  );
};

export default Legend;